import * as React from "react";
import styles from './index.module.css';

const SvgComponent = (props) => (
    <div className={`${styles.render} ${props.show && styles.show} cursor-pointer w-[28px] h-[28px] flex items-center justify-center`}>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={30}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill={props.color}>
      <path
        d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
        opacity={0.5}
      />
      <path d="M15.75 12a.75.75 0 0 1-.75.75H9a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 .75.75Z" />
    </g>
  </svg>
  </div>
)
export default SvgComponent
